import React from 'react';
import { ProgramAttachment } from '../../types';
import { AttachmentCellProps } from './AttachmentCellProps';
import { BinIcon, DownloadIcon } from '../../../assets/icons';
import { StyleVariables } from '../../../commons/styleConstants';
import { GrowegyMenu } from '../../../commons/components/GrowegyMenu';
import { mobileConfig } from '../../../commons/config';

export const AttachmentMenuCell = ({
  value,
  actions,
  row,
  hasDeleteAccess,
}: AttachmentCellProps<ProgramAttachment, ProgramAttachment>) => {
  return (
    <GrowegyMenu
      menuItems={[
        {
          type: 'standard',
          text: 'Delete',
          icon: <BinIcon fill={StyleVariables.black2} />,
          isHidden:
            row.original.status !== 'NEW' &&
            (row.original.status !== 'EXISTED' || !hasDeleteAccess),
          dataTest: `attachments-table__delete-action-${row.index}`,
          onClick: () => actions.delete(value),
        },
        {
          type: 'standard',
          text: 'Download',
          icon: <DownloadIcon fill={StyleVariables.black2} />,
          isHidden: row.original.status !== 'EXISTED' || mobileConfig().isMobile,
          dataTest: `attachments-table__download-action-${row.index}`,
          onClick: () => actions.download(value),
        },
      ]}
      menuButtonDataTest={`attachments-table__actions-${row.index}`}
    />
  );
};
